let backendUrl, tempIamUrl;

const hostname = window.location.hostname;

if (hostname === "central-admin.sarvagram.com") {
  backendUrl = "https://gateway.sarvagram.com/admin/v1.0";
  tempIamUrl = "https://gateway.sarvagram.com";
} else if (hostname === "uat-central-admin.sarvagram.net") {
  backendUrl = "https://uat-api.sarvagram.net/admin/v1.0";
  tempIamUrl = "https://uat-api.sarvagram.net";
} else {
  backendUrl = "https://dev-api.sarvagram.net/admin/v1.0";
  tempIamUrl = "https://dev-api.sarvagram.net";
}

export const API_URL = backendUrl;

export const iamUrl = tempIamUrl;

export const FrontendURL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
export const FileUrl = `${window.location.protocol}//${window.location.hostname}/`;
